import { reportIcon } from "assets/icons/svgIcons";

export default [
  {
    id: "eod_reports_parent",
    title: "EOD Reporting",
    pageTitle: "EOD Reporting",
    icon: reportIcon,
    type: "collapse",
    permissions: ["site_admin", "facility_manager"],
    children: [
      {
        id: "eod_dashboard",
        title: "Dashboard",
        pageTitle: "EOD Dashboard",
        icon: reportIcon,
        navLink: "/eod/dashboard",
        type: "item",
        permissions: ["site_admin", "facility_manager"],
      },
      {
        id: "eod_reports",
        title: "Reports",
        pageTitle: "EOD Reports",
        icon: reportIcon,
        navLink: "/eod/reports",
        type: "item",
        permissions: ["site_admin", "facility_manager"],
      },
      {
        id: "eod_inventories",
        title: "Inventories",
        pageTitle: "EOD Inventories",
        icon: reportIcon,
        navLink: "/eod/inventories",
        type: "item",
        permissions: ["site_admin"],
      },
      {
        id: "eod_submit",
        title: "Submit EOD",
        pageTitle: "Submit EOD",
        icon: reportIcon,
        navLink: "/eod/reports/submit",
        type: "item",
        permissions: ["facility_manager"],
      },
    ],
  },
];
